// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bam_a"};